import s from "styled-components";
import { Input } from "../index-styled";
import { Button } from "_c/button";
import { Link } from "react-router-dom";

export const FormsContainer = s.div`
  margin-top: 20px;
`;
export const Wrap = s.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  min-height: 350px;
  margin: 0 auto;
  ${Input} {
    width: 100%;
  }
`;
export const InputSect = s.div`
  display: flex;
  flex-direction: column;
`;
export const SubmitButton = s(Button)`
  margin-top: 5px;
`;
export const Attention = s.p`
  margin-top: 10px;
  max-width: 320px;
  line-height: 15px;
  font-size: 12px;
  font-weight: 500;
  color: var(--font-color-main);
  margin-bottom: 0;
`;
export const Politics = s(Link)`
  font-weight: 600;
  color: var(--color-cta);
  transition: opacity .35s ease;
  :hover {
    opacity: .7;
  }
`;
export const MaybeDisabled = s.div`
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;
